// extracted by mini-css-extract-plugin
export default {"ClientBadge":"Styles_ClientBadge__SEHlO","ClientLogo":"Styles_ClientLogo__oUHYJ"};